<style lang="less">
	.text-white{
		color: white;
	}
	.drag-container{
		max-width: 100% !important;
	}
	.drag-column{
		background: rgba(0, 0, 0, 0.05);
		overflow: show;

		h2{
			font-weight: 300;
			font-size: 1rem;
		}
		.drag-column-header{
			padding-bottom: 0px;
		}
	}
	ul.drag-list{
		margin-bottom: 100px;
	}
	.drag-item{
		background-color: transparent;
		color: initial;
		margin: 0px;
		height: 100%;
	}
	
</style>
<template>
	<div >	
		<h1 class="mw-h1">Tasks</h1>
			<v-card v-if="view == 'admin'" class="pa-3">
				<v-row>
					<v-col>
						<v-row>
							<v-switch label="Only my tasks" class="ml-2" v-model="myTasks" color="green" :value="true"></v-switch>
							<v-switch label="Hide backlog" class="ml-2" v-model="hideBacklog" color="green" :value="true"></v-switch>
						</v-row>
					</v-col>
					<v-col>
						<v-tabs v-model="tab" right>
							<v-tab href="#board">Board</v-tab>
							<v-tab href="#list">List</v-tab>
						</v-tabs>					
					</v-col>
				</v-row>
				<v-tabs-items v-model="tab">
					<v-tab-item value="board">
						<kanban-board :blocks="filteredTasks" :stages="filteredStatuses" @update-block="updateBlock">
							<v-col v-for="status in statuses" :slot="status" :key="status" class="pa-0 ma-0">
								<h2>{{ prettyPrint(status, 'TITLE') }}</h2>
							</v-col>						
							<TaskTile v-for="task in filteredTasks" :slot="task.id" :key="task.id" :task="task" v-on:clicked="editTask(task)" :truncate="true"></TaskTile>						
						</kanban-board>	
					</v-tab-item>
					<v-tab-item value="list">
						<div>
							<TaskTile class="mb-3" v-for="task in filteredTasks" :slot="task.id" :key="task.id" :task="task" :truncate="false" v-on:clicked="editTask(task)"></TaskTile>
						</div>
					</v-tab-item>
				</v-tabs-items>
			<p class="text-right">
				<v-btn color="green" dark @click="newTask">New Task</v-btn>
				<v-dialog v-model="dialog">
					<v-card class="mt-4 ">
						<TaskForm v-on:created="closeDialog" :editing="editing"></TaskForm>
					</v-card>
				</v-dialog>
			</p>
		</v-card>
	</div>
</template>
<script>
	import Vuex from "vuex"
	import TaskForm from "../components/forms/TaskForm.vue";
	import TaskTile from "../components/singles/TaskTile.vue";
	import { prettyPrint } from "../assets/utilities.js"
	export default {
		name: "SystemTasks",
		data:() => {
			return {
				tab: "board",
				dialog: false, 
				editing: false,
				myTasks: false, 
				hideBacklog: false,
			}
		}, 
		components: {
			TaskForm: TaskForm,
			TaskTile: TaskTile
		},
		computed: {
			...Vuex.mapState( {
				user: state => state.auth.user,
				view: state => state.auth.view,
				tasks: state => {
					var tasks = state.admin.tasks;
					tasks.map( task => { 
						if( typeof task.position == 'undefined' ){
							task.position = tasks.length;
						}
					})

					tasks.sort( (a, b) => {
						return a.position - b.position
					})
					return tasks
				},
				statuses: state => state.settings.taskStatuses
			}), 
			filteredStatuses(){
				if( !this.hideBacklog ){
					return this.statuses;
				}
				else{
					return this.statuses.filter( a => a !== "backlog" )
				}
			},
			filteredTasks(){
				var tasks = [...this.tasks]
				if( this.myTasks ){
					var user = this.user.uid;
					tasks = tasks.filter( t => t.assignedTo == user)
				}
				if( this.hideBacklog ){
					tasks = tasks.filter( t => t.status !== 'backlog' )
				}
				return tasks;
			}
		},
		methods: {
			prettyPrint: prettyPrint,
			updateBlock(id, status, index ) {
				var task = this.tasks.find(b => b.id == id);
				task.status = status;
				task.position = index;
				this.$store.dispatch( "updateDoc", {
					doc: "tasks/" + id,
					action: "update",
					data: {status: status, position: index}
				} )
			},
			newTask(){
				this.editing = false;
				this.dialog = true;
			},
			editTask( task ){
				this.editing = task;
				this.dialog = true;
			},
			closeDialog(){
				this.dialog = false;
			}
		}, 
		watch: {
			view: {
				immediate: true, 
				handler() {
					if( this.view == 'admin'){
						this.$store.dispatch("fetch", "tasks")
						this.$store.dispatch("fetch", "admins");
					}
				}
			}
		}
	}
</script>